import { useState, useEffect, useRef, useCallback } from 'react';
import useSlingApi from '@sdk/api/useSlingApi';

import { getToastIntegrationStatus } from '@web/components/npsScore/npsScore.hooks';
import {
  sendSurveyFeedback,
  shouldCheckForHappinessSurvey,
} from '@web/components/happinessSurvey/utils';

const DISPLAY_DELAY = 10 * 1000;

export const useHappinessSurvey = (
  user,
  locationsCount,
  usersCount,
  saveClientFlags,
  areShiftsPublished,
  score,
  comment,
  onScheduleTab,
  forceDisplay,
  onClose
) => {
  const feedbackSentRef = useRef(false);
  const [isVisible, setIsVisible] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [wasDisplayed, setWasDisplayed] = useState(false);
  const api = useSlingApi();

  const shouldDisplaySurvey = shouldCheckForHappinessSurvey(
    user,
    areShiftsPublished,
    onScheduleTab
  );

  const submitSurvey = useCallback(async () => {
    const { data: integrations } = await api.integrations.getAvailableIntegrations();
    const toastIntegrationStatus = getToastIntegrationStatus(integrations, user);

    await sendSurveyFeedback(
      { score, comment },
      { user, saveClientFlags, usersCount, locationsCount },
      toastIntegrationStatus
    );
  }, [locationsCount, saveClientFlags, user, usersCount, score, comment]);

  const closeModal = () => {
    if (!feedbackSentRef.current) {
      submitSurvey();
    }
    setIsVisible(false);
    setWasDisplayed(true);
    onClose?.();
  };

  useEffect(() => {
    if ((shouldDisplaySurvey && !wasDisplayed) || forceDisplay) {
      setTimeout(() => {
        setIsVisible(true);
        setWasDisplayed(true);
      }, DISPLAY_DELAY);
    }
  }, [user, shouldDisplaySurvey, wasDisplayed, forceDisplay]);

  useEffect(() => {
    if (!feedbackSentRef.current && submitted) {
      submitSurvey();
      feedbackSentRef.current = true;
    }
  }, [submitted, submitSurvey, user]);

  return {
    isVisible,
    closeModal,
    setSubmitted,
  };
};
